const withBankInfo =
  (Component) =>
  ({ data, open, setOpen }) => {
    const listToRender = [
      { label: "iban", value: data?.iban },
      { label: "ifsc", value: data?.ifsc },
      { label: "accountNo", value: data?.accountNo },
      { label: "branchName", value: data?.branchName },
    ];
    return <Component type="Bank" listToRender={listToRender} open={open} setOpen={setOpen} />;
  };
export default withBankInfo;
